import PropTypes from "prop-types";

const reqSVG = require.context("assets/icons", true, /\.svg$/);

const Icon = props => {
  const { size, name, className } = props;

  return reqSVG(`./${name}.svg`)({
    className,
    width: size,
    height: size,
    viewBox: `0 0 ${size} ${size}`
  });
};

Icon.defaultProps = {
  size: 16
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string
};

export default Icon;
